import axios from "axios";
import { getLocalStorage } from "../utils/localStorage";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

api.interceptors.request.use(
  (config) => {
    const userId = getLocalStorage("_tokens", false, true);
    
    if (userId) {
      if(config.url.includes('refresh-login')){
        config.headers["Authorization"] = `Bearer ${userId.refreshToken}`
      }else{
        config.headers["Authorization"] = `Bearer ${userId.token}`
      }
    };
    return config;
  },
  (error) => {
    throw error;
  }
);

export default api;
